<template>
  <div class="menus-body">
    <ul class="items custom-scroll" id="listaPlatos" ref="listaPlatos">
      <li class="item" v-for="plato in platosOrdenados" :data-item="plato | serialized" :key="plato._id">
        <div class="overlay"></div>
        <div class="label-category">
          <span class="category-name">{{plato.categoria.nombre}}</span>
          <div class="btn-group pull-right">
            <router-link :to="'/platoform/edit/' + plato._id" title="Editar" class="btn btn-xs btn-ghost"><i class="fa fa-pencil"></i></router-link>
            <a href="#" class="btn btn-xs btn-ghost" title="Cambiar stock"><i class="fa fa-cubes"></i></a>
            <a href="#" class="btn btn-xs btn-ghost" title="Marcar como no publicado"><i class="fa fa-times"></i></a>
          </div>
        </div>
        <div class="menus-item-photo" :style="{backgroundImage: 'url(' + plato.urlThumb + ')'}"></div>
        <div class="menus-item-detail">
          <p class="menus-item-name">{{plato.nombre}}</p>
        </div>
        <div class="label-stock"><span>SIN STOCK</span></div>
      </li>
      </li>
    </ul>
  </div>
</template>
<script>
  import $ from 'jquery'
  import '../../assets/js/jquery-ui.min.js'
  import _ from 'lodash'
  import '../../assets/css/agregados.css'
  export default {
    data () {
      return {}
    },
    computed: {
      platosOrdenados () {
        let ordenados = _.sortBy(this.platos, (plato) => {
          return plato.nombre
        })
        return ordenados
      }
    },
    props: ['platos'],
    methods: {
      activarDragDrop () {
        const me = this
        $(me.$refs.listaPlatos).find('.item').each((idx, val) => {
          let $item = $(val)
          let tituloItem = $item.find('.category-name').text().toUpperCase() + ' ' + $item.find('p.menus-item-name').text()
          let tituloPlato = $item.find('p.menus-item-name').text()
          let plato = $item.data('item')
          // console.log(tituloItem)
          $item.data('event', {
            order: tituloItem, // use the element's text as the event title
            title: tituloPlato,
            idPlato: plato._id,
            plato: plato,
            stick: true // maintain when user navigates (see docs on the renderEvent method)
          })
          $item.draggable({
            zIndex: 999,
            revert: true,      // will cause the event to go back to its
            revertDuration: 0  //  original position after the drag
          })
        })
      }
    },
    filters: {
      serialized (value) {
        return JSON.stringify(value)
      }
    },
    updated () {
      this.activarDragDrop()
    }
  }
</script>
<style scoped>
/*
.items {
  height: 500px;
  overflow:hidden;
  overflow-y: scroll;
  overflow-x: hidden;
}
*/
.items .custom-scroll::-webkit-scrollbar {
  -webkit-overflow-scrolling: touch;
  height: 10px;
  width: 6px;
}
.items .custom-scroll::-webkit-scrollbar:hover {
  background-color: #E9E9E9;
  border: 1px solid #dbdbdb;
}
.items .custom-scroll::-webkit-scrollbar-button:start:decrement,
.scrollable::-webkit-scrollbar-button:end:increment {
  background: transparent;
  display: block;
  height: 0;
}
.items .custom-scroll::-webkit-scrollbar-track {
  background-clip: padding-box;
  border-width: 0 0 0 2px;
  border: solid transparent;
}
.items .custom-scroll::-webkit-scrollbar-track-piece {
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  -webkit-border-radius: 0;
  background-color: transparent;
  border-radius: 0;
}
.items .custom-scroll::-webkit-scrollbar-thumb {
  -moz-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.07);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.07);
  background-clip: padding-box;
  background-color: rgba(0, 0, 0, 0.2);
  border-width: 0;
  border: none;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.07);
}
.items .custom-scroll::-webkit-scrollbar-thumb:vertical,
.scrollable::-webkit-scrollbar-thumb:horizontal {
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  -webkit-border-radius: 0;
  background-color: #ddd;
  border-radius: 0;
}
.items .custom-scroll::-webkit-scrollbar-thumb:active {
  -moz-box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.33);
  -webkit-box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.33);
  background-color: rgba(0, 0, 0, 0.44);
  box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.33);
}
.items .custom-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}
</style>



// WEBPACK FOOTER //
// ListaPlatos.vue?b7962a38